import { gql } from '@apollo/client';

export const GET_GAME_IQ_QUESTIONS = gql`
  query GetGameIQQuestions($sport: String!, $level: Int!) {
    getGameIQQuestions(sport: $sport, level: $level) {
      _id
      sport
      level
      questionText
      options {
        label
        text
      }
      correctAnswer
    }
  }
`;